import { axios } from 'lib/axios';

export const emailOTPSetup = async (data) => {
  return await axios.patch('/user/emailOTPLogin/setup', data);
};
